import { InitiativeCreationStep } from '@app/pages/dashboard/initiative/shared/workflow'
import { NotificationFrequency } from '@schema/user'
import { InitiativeUserRole, NumberOfHomes } from 'schema/initiative'
import { PlotApplicationStatus } from 'schema/plot'
import { PhaseType } from '@schema/phase'

type Translation<T extends string | number | symbol> = {
  [K in T]: string
}

export const phaseTranslations: Translation<PhaseType> = {
  idea: 'Ideefase',
  location: 'Locatiefase',
  design: 'Ontwerpfase',
  construction: 'Bouwfase',
  living: 'Woonfase',
} as const

export const plotApplicationStatusesTranslations: Translation<PlotApplicationStatus> =
  {
    applicationOpen: 'Inschrijving open',
    applicationClosed: 'Inschrijving gesloten',
    inPreparation: 'In voorbereiding',
  } as const

export const initiativeUserRoleTranslation: Translation<InitiativeUserRole> = {
  owner: 'Initiatiefnemer',
  admin: 'Beheerder',
  member: 'Deelnemer',
  applicant: 'Aanvrager',
  follower: 'Volger',
} as const

// Note: AgeCategory, HousingTypePreference, OwnershipPreference are now schema entities
// and no longer enum types. These translations are kept for reference but not type-safe.

export const notificationFrequencyTranslation: Translation<NotificationFrequency> =
  {
    weekly: 'Wekelijks',
    fortnightly: 'Tweewekelijks',
    monthly: 'Maandelijks',
    never: 'Nooit',
  } as const

export const initiativePhaseNameTranslation: Translation<PhaseType> = {
  idea: 'Ideefase',
  location: 'Locatiefase',
  design: 'Ontwerpfase',
  construction: 'Bouwfase',
  living: 'Woonfase',
} as const

export const initiativePhaseDescriptionTranslation: Translation<PhaseType> = {
  idea: 'Je hebt een eerste idee dat je met anderen wil delen.',
  location:
    'Je zoekt samen met je groep naar een locatie voor jullie initiatief.',
  design:
    'Je werkt samen met je groep aan het ontwerp van jullie droomwoningen.',
  construction: 'De bouw is gestart en jouw woondroom wordt gerealiseerd.',
  living:
    'Je woont in een gerealiseerd zelfbouwproject en wil anderen inspireren.',
} as const

export const initiativeCreationStepTitleTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: 'In welke fase zit jouw initiatief?',
    mainDetails: 'Overzicht',
    pageContent: 'Jouw verhaal',
    livingParameters: 'Hoe wil je bouwen en wonen?',
    membersParameters: 'Omvang, locatie en budget',
    legalInfo: 'Juridisch',
    amenities: 'Voorzieningen',
    contactDetails: 'Contact',
    callSchedule: 'Nog één laatste stap',
    finish: 'Je bent klaar!',
  } as const

export const initiativeCreationStepDescriptionTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: null,
    mainDetails: null,
    pageContent: null,
    livingParameters: null,
    membersParameters: null,
    legalInfo: null,
    amenities: null,
    contactDetails: null,
    callSchedule:
      'We horen graag meer over jouw initiatief en hoe we je verder kunnen helpen. Plan een afspraak in via de kalender hiernaast.', //'Leer de basiskennis van collectieve zelfbouw in ons toegankelijke online leerprogramma.',
    finish:
      'Na ons gesprek komt je initiatief online. Benieuwd naar de volgende stap? Lees meer in onze Kennishub en E-learnings.', //'Looking for what to do next before your call? Check these articles.\nOr visit our E-learnings to learn more about collective building.',
  } as const

export const humberOfHomesTranslation: Translation<NumberOfHomes> = {
  lessThan5: '1-4',
  from5To10: '5-10',
  from11to30: '11-30',
  moreThan30: '30+',
} as const
